var _path, _polygon, _path2, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.06,465.3c0,.15-88.68.26-198,.26s-198.07-.11-198.07-.26S140.6,465,250,465,448.06,465.16,448.06,465.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.49,93.59c.43-7.51,5.05-12.13,11.53-16a23.44,23.44,0,0,1,21.66-1c4.55,2.16,8.53,5.86,13.52,6.5,8.22,1.06,16-6.56,24.07-4.65a10.69,10.69,0,0,1-.78,21c5.38.79,8.43,7.59,6.44,12.66s-7.64,8-13.08,8.12-10.67-2.11-15.37-4.84-9.1-6-14-8.36-10.55-3.72-15.81-2.32c-7.11,1.89-12.16,8.61-14,15.74s-1.06,14.66.05,21.94,2.51,14.62,1.81,22a2.72,2.72,0,0,1-1,2.27c-1.09.6-2.34-.43-3.15-1.39A108.2,108.2,0,0,1,249,128.42c-2.48-7.81-3.85-15.4-.87-23s13-14.9,19.35-11.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.56,129.91l12,74.24c2.25,13.86,11.26,27.25,33,22.7h0c18.57-5.37,17.19-18.73,14.77-35.21h0s20.44-5.32,18.61-26.1c-.89-10-4.39-30.58-7.78-49.12a38.85,38.85,0,0,0-42.12-31.66l-2,.2C265.61,88.39,256.54,108.54,260.56,129.91Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,191.64s-13,2.08-27.83-5.27c0,0,8.15,15.44,28.68,11.48Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.17,137.21a3,3,0,0,1-2.56,3.27,2.84,2.84,0,0,1-3.32-2.36,3,3,0,0,1,2.55-3.28A2.85,2.85,0,0,1,324.17,137.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.78,127.05c-.33.42-2.75-1-5.94-.68s-5.36,2.16-5.75,1.8c-.18-.15.12-.89,1.06-1.73a8.25,8.25,0,0,1,4.56-1.93,7.93,7.93,0,0,1,4.77,1C327.54,126.19,327.94,126.86,327.78,127.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.28,139.12a3,3,0,0,1-2.55,3.28A2.85,2.85,0,0,1,288.4,140a3,3,0,0,1,2.56-3.28A2.85,2.85,0,0,1,294.28,139.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.48,130.8c-.33.42-2.74-1-5.93-.68s-5.37,2.16-5.75,1.8c-.19-.16.11-.89,1.06-1.74a8.17,8.17,0,0,1,4.56-1.92,7.88,7.88,0,0,1,4.77,1C296.24,129.94,296.64,130.61,296.48,130.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.44,153.29c0-.18,1.91-.72,5.08-1.45.81-.17,1.56-.41,1.64-1a4.1,4.1,0,0,0-.78-2.36q-1.45-2.83-3-6c-4.24-8.49-7.39-15.51-7.05-15.68s4.06,6.58,8.29,15.08c1,2.09,2,4.09,2.94,6a4.79,4.79,0,0,1,.74,3.16,2,2,0,0,1-1.22,1.32,5.5,5.5,0,0,1-1.36.34C312.47,153.25,310.47,153.47,310.44,153.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.05,118.22c-.23.89-3.46.8-7.15,1.63s-6.62,2.15-7.2,1.43c-.26-.35.19-1.22,1.32-2.19a12.17,12.17,0,0,1,5.2-2.42,12.31,12.31,0,0,1,5.73.09C295.38,117.18,296.14,117.79,296.05,118.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,117.94c-.48.78-2.76.25-5.4.48s-4.83,1-5.42.27c-.27-.35,0-1.11.92-1.89a7.87,7.87,0,0,1,8.73-.61C325.5,116.84,325.89,117.56,325.67,117.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.8,145.11c-.37-.12-14.68-2.79-12.8,11.36s15.69,9.34,15.66,8.93S263.8,145.11,263.8,145.11Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,160.62c-.07,0-.23.2-.62.45a2.46,2.46,0,0,1-1.83.28c-1.57-.35-3.15-2.56-3.55-5.1a8.19,8.19,0,0,1,.22-3.62,2.83,2.83,0,0,1,1.6-2.13A1.24,1.24,0,0,1,259,151c.25.37.19.66.27.68s.27-.28.08-.85a1.56,1.56,0,0,0-.67-.81,1.87,1.87,0,0,0-1.41-.18,3.51,3.51,0,0,0-2.29,2.53,8.53,8.53,0,0,0-.33,4.06c.47,2.84,2.29,5.31,4.41,5.63a2.68,2.68,0,0,0,2.21-.67C261.65,161,261.68,160.63,261.63,160.62Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.52,97.06c-2.26-3.89-5.88-6.82-9.73-9.16A46.5,46.5,0,0,0,292,81a37.87,37.87,0,0,0-25.4,12.64,40,40,0,0,0-8.91,21.16,58.68,58.68,0,0,0,2.18,23c.93,3.28,2.19,6.65,4.78,8.87,1.62,1.38,4.23,2.14,5.78.68a5.69,5.69,0,0,0,1.32-3.44c1.63-11.23,3.14-23.27-1.93-33.42a32.89,32.89,0,0,1,8.87-10,17,17,0,0,1,12.72-3.06c6.52,1.32,11,7.08,16.52,10.85a30.08,30.08,0,0,0,27.23,3.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.24,161.91a13.84,13.84,0,0,1-1.06,3.9,4.73,4.73,0,0,1-2.92,2.62,4.25,4.25,0,0,1-3.95-1.19,6.83,6.83,0,0,1-1.84-3.83c-.21-1.29.06-2.93,1.29-3.34a3.25,3.25,0,0,1,1.61,0l7.22,1.3",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73,167.94c-.07-.2-1.41.69-3.64.3a5.17,5.17,0,0,1-3.19-1.87,5.53,5.53,0,0,1-1-4.34,4.55,4.55,0,0,1,.38-1.11c.2-.33.16-.31.45-.33s.77.13,1.15.2l1.19.21c1.54.28,2.94.51,4.11.69,2.35.36,3.82.5,3.85.34s-1.37-.6-3.68-1.18c-1.15-.28-2.53-.61-4.06-.94l-1.18-.26a12.58,12.58,0,0,0-1.32-.25,1.58,1.58,0,0,0-1,.24,1.83,1.83,0,0,0-.61.73,5.94,5.94,0,0,0-.48,1.42,6.34,6.34,0,0,0,1.31,5.28,5.81,5.81,0,0,0,4,2,5.39,5.39,0,0,0,2.9-.49C311.51,168.29,311.77,168,311.73,167.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,81.37a3.79,3.79,0,0,1,.28.94,9.07,9.07,0,0,1,.09,2.78,13,13,0,0,1-5.13,8.69c-3.48,2.77-9,3.88-14.65,3s-11.49-3.55-17.49-6S294,86.63,288.43,87.65a22.3,22.3,0,0,0-12.61,7.21,29.76,29.76,0,0,0-5.39,8.44c-.91,2.21-1.22,3.5-1.32,3.48a4.47,4.47,0,0,1,.18-1,25.29,25.29,0,0,1,.8-2.65,28.46,28.46,0,0,1,5.24-8.75,22.74,22.74,0,0,1,12.95-7.61c5.77-1.11,12.15.61,18.18,3.11s11.7,5.22,17.26,6,10.78-.13,14.14-2.69A13,13,0,0,0,343,85.05,14.48,14.48,0,0,0,343,81.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,124.47a10,10,0,0,1,.55-3.91,24.48,24.48,0,0,1,8-12.31,8.92,8.92,0,0,1,3.88-2,4.73,4.73,0,0,1,3,.34c.63.32.87.65.83.69a5.48,5.48,0,0,0-3.65-.39c-2.22.57-4.72,3-7,5.76a28.36,28.36,0,0,0-4.4,8.14C250.51,123,250.28,124.49,250.13,124.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.88,136.71a10.92,10.92,0,0,1,.8-3.89,26.44,26.44,0,0,1,12.12-14.5,11,11,0,0,1,3.69-1.48,38.8,38.8,0,0,1-3.35,2,30.32,30.32,0,0,0-11.85,14.17A38,38,0,0,1,253.88,136.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.08,216.82s15.17,19.57,18.82,26.92,29.81,88.56,29.81,88.56l-11.35,4.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.05 198.5 269.05 188.69 324.17 206.62 338.93 230.25 350.31 263.26 318.41 215.31 269.05 198.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,207.93s-23.38,28-22.88,46.16c.5,17.91,24.79,126.74,24.79,126.74l-5.88,19.45-6.37,64.82h132.5l-9.22-132.8c-1.47-.08-29-76.11-29-76.11L318.84,213.4l-50.75-18.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.74,300.67s9.27-.36,14.11,1.8,8.93,1.08,12.35,7.77,7.42,9.72,8.26,19.87-10.12,33.67-17.36,37S366.74,300.67,366.74,300.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.09,299.75s54.17,50.85,61.06,55.71,7.91,35.61,16.4,36.2,36-19.76,36-19.76l-81.49-76.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M339.37,345.28s-11.78,15.07-13.13,18.85-2.66,6.29-1.22,7.55a3.69,3.69,0,0,0,4.13.87c1.92-.74,11.39-13.23,11.39-13.23s-12.56,17.91-13.13,21,1.89,4.59,4.77,4.05,8.36-8.63,8.36-8.63-7.77,9-6.13,10.52,3.53,1.71,5.69.63,7.64-8.18,7.64-8.18-3.78,4-1.71,5,2.25,1.1,4.05-.39,17.68-17,17.68-17l-10-6.86Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.2,354.49a21.2,21.2,0,0,1-1.84,2.52l-4.6,6c-1.8,2.33-3.49,4.4-4.77,5.86a15.89,15.89,0,0,1-2.16,2.26,20.77,20.77,0,0,1,1.88-2.5l4.64-5.94c1.8-2.33,3.47-4.42,4.72-5.9A16.41,16.41,0,0,1,344.2,354.49Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,361.71a98.24,98.24,0,0,1-6.28,7.82,98.4,98.4,0,0,1-6.68,7.48,95.57,95.57,0,0,1,6.28-7.82A98.4,98.4,0,0,1,352.55,361.71Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.24,366.24a96.93,96.93,0,0,1-6.58,7.57,95.54,95.54,0,0,1-7,7.22,98.69,98.69,0,0,1,6.58-7.57A93.29,93.29,0,0,1,359.24,366.24Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.94,225.34c7.61-1.61,17.27-2.28,24.63,1.89l40.19,36.26s56.65,63.55,58.87,67.09,5.21,24.46-3.37,35.12S375,372.26,364,369.75c-8.71-2-69.62-46.75-94.66-65.34a47.8,47.8,0,0,1-17.8-26,57.69,57.69,0,0,1-2-20.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,257.8s0,.36-.07,1.05-.1,1.71-.12,3.06a58.66,58.66,0,0,0,1.18,11.71,61.52,61.52,0,0,0,2.2,8.21,46.28,46.28,0,0,0,4.39,9.1,48,48,0,0,0,7.27,9c2.91,2.92,6.53,5.38,10.2,8.12,14.76,10.87,32.35,23.78,52.16,37.73,5,3.48,10.06,7,15.31,10.56s10.65,7.14,16.34,10.44A44.22,44.22,0,0,0,362.8,369a12.58,12.58,0,0,0,2.35.71l2.44.59a67.59,67.59,0,0,0,9.89,2,16.66,16.66,0,0,0,9.81-1.79,20.16,20.16,0,0,0,7.26-7.13c2.89-5,3.95-10.8,4.14-16.43a52.62,52.62,0,0,0-.34-8.43c-.17-1.38-.4-2.76-.69-4.11a13.2,13.2,0,0,0-1.35-3.83c-1.64-2.16-3.5-4.24-5.25-6.32l-5.32-6.14L375.29,306.2l-37.68-42.58v0l-40.14-36.32,0,0a25.56,25.56,0,0,0-10.29-3,43.86,43.86,0,0,0-7.88.07c-2.11.21-3.71.48-4.78.66l-1.2.22c-.27.05-.41.06-.41.06s.54-.13,1.6-.35,2.66-.49,4.78-.72a43.45,43.45,0,0,1,7.91-.13,25.8,25.8,0,0,1,10.4,3h0l40.25,36.19h0c11.28,12.63,24,26.95,37.75,42.52l10.46,11.92,5.32,6.14c1.78,2.09,3.59,4.12,5.3,6.37a6.27,6.27,0,0,1,.51,1c.14.33.24.66.36,1,.23.67.38,1.35.55,2,.3,1.37.53,2.76.7,4.16a53.57,53.57,0,0,1,.35,8.51c-.2,5.68-1.26,11.56-4.22,16.68a20.58,20.58,0,0,1-7.45,7.32,17.23,17.23,0,0,1-10.1,1.84,67.12,67.12,0,0,1-10-2l-2.44-.59a13.43,13.43,0,0,1-2.42-.73,43.26,43.26,0,0,1-4.45-2.28c-5.72-3.32-11.1-6.93-16.36-10.46s-10.36-7.1-15.31-10.59c-19.81-14-37.38-26.91-52.11-37.82-3.65-2.75-7.28-5.23-10.21-8.18a48.24,48.24,0,0,1-7.29-9.11,46.82,46.82,0,0,1-4.37-9.16,61,61,0,0,1-2.17-8.26,56.79,56.79,0,0,1-1.08-11.75A33,33,0,0,1,249.55,257.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.45,260.85l-.23-.14-.64-.48c-.54-.43-1.4-1-2.4-1.89-2.07-1.68-4.9-4.29-8.29-7.62s-7.31-7.42-11.77-11.84c-2.24-2.19-4.59-4.5-7.16-6.74a74.42,74.42,0,0,0-8.3-6.49c-1.22-.88-2.54-1.55-3.77-2.3l-.18-.11,0-.18c.21-.91.42-1.81.62-2.69l.17.3L278.76,211l-9.11-2.92-2.44-.81-.64-.22-.21-.09s.08,0,.23,0l.64.18,2.48.72,9.16,2.78,30.83,9.52.22.07-.05.23c-.2.88-.4,1.78-.61,2.69l-.13-.28c1.25.76,2.59,1.44,3.81,2.32a72.93,72.93,0,0,1,8.35,6.54c2.58,2.26,4.93,4.58,7.17,6.79,4.44,4.45,8.33,8.55,11.69,11.91s6.14,6,8.16,7.73c1,.9,1.81,1.51,2.34,2l.61.51A1.26,1.26,0,0,1,351.45,260.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.34,301.79a17.13,17.13,0,0,1-1.13-2.05L367.32,294c-2.42-4.87-5.72-11.6-9.34-19.06s-6.86-14.23-9.18-19.14c-1.12-2.42-2.05-4.39-2.72-5.83-.29-.65-.53-1.18-.71-1.6a2.47,2.47,0,0,1-.22-.57,2.38,2.38,0,0,1,.31.53c.21.4.48.92.8,1.55.71,1.42,1.69,3.37,2.87,5.76,2.42,4.93,5.7,11.65,9.32,19.07l9.2,19.13,2.75,5.81A23,23,0,0,1,371.34,301.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,411.49l.36,0,1,.07,4,.32,14.62,1.26L347,417.57l-.28.31L343.51,405c-.5-2-1-4-1.48-6l.23.2-55.2-6.41.17-.09c-3.24,5.75-5.74,10.38-7.37,13.61-.81,1.61-1.4,2.87-1.76,3.74a7.4,7.4,0,0,0-.34,1,1.14,1.14,0,0,0-.05.35,2.54,2.54,0,0,1,.3-1.39c.33-.89.9-2.17,1.69-3.8,1.58-3.25,4-7.91,7.23-13.69l.06-.1.11,0,55.22,6.23.18,0,0,.18,1.48,6c1.08,4.4,2.15,8.71,3.17,12.84l.09.35-.36,0-49.41-4.62-14.57-1.41-3.9-.4-1-.11A1,1,0,0,1,277.71,411.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "279.5 411.66 281.87 417.82 346.94 421.7 346.94 417.82 279.5 411.66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190,101.56c-.2-3.48-3.09-6.39-6.41-7.44s-7-.52-10.27.58c-7.21,2.39-13.27,7.29-19.15,12.1-9.13,7.45-18,17.69-21.48,29-2.63,8.48-3.39,14-.69,23,2.38,8,4.27,15.71,3.8,22.39-.75,10.55-2,13-4.74,23.38-1.69,6.47,4.08,23.4,4.08,23.4l36.49-14c13-6.12,41.06-17.54,41.06-17.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.51,225.29c.06-8.88.15-15.06.14-15s-15.93-3.68-19.14-26.4a225,225,0,0,1-1.22-44.36c1.09-13.58,10.39-30.11,23.91-28.45l42.12,11.42c4.11.51,5.48,4,5.33,8.15l.31,1.94-3.09,64.88,1.33,27.59c-.54,12.33-12.73,23.54-25.06,24.1h0A23.52,23.52,0,0,1,169.51,225.29Z",
    style: {
      fill: "#b56760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,157.63a2.91,2.91,0,0,0,2.75,3,2.78,2.78,0,0,0,3-2.57,2.91,2.91,0,0,0-2.75-3A2.78,2.78,0,0,0,158.83,157.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,149.76c.35.38,2.58-1.21,5.71-1.15s5.39,1.67,5.74,1.29c.17-.17-.19-.86-1.18-1.6a7.92,7.92,0,0,0-4.58-1.5,7.63,7.63,0,0,0-4.56,1.38C155.17,148.9,154.83,149.58,155,149.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1,157.29a2.91,2.91,0,0,0,2.75,3,2.78,2.78,0,0,0,3-2.57,2.89,2.89,0,0,0-2.74-3A2.77,2.77,0,0,0,188.1,157.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,149.67c.36.38,2.59-1.21,5.72-1.15s5.39,1.67,5.74,1.29c.17-.17-.19-.86-1.18-1.6a7.92,7.92,0,0,0-4.58-1.5,7.69,7.69,0,0,0-4.56,1.38C185.17,148.81,184.83,149.49,185,149.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.45,173.32c0-.17-1.92-.54-5.07-1-.79-.1-1.55-.27-1.67-.82a4,4,0,0,1,.57-2.35l2.47-6.05c3.43-8.6,5.92-15.68,5.57-15.81s-3.4,6.73-6.83,15.33c-.83,2.12-1.62,4.14-2.37,6.08a4.58,4.58,0,0,0-.47,3.12,2,2,0,0,0,1.29,1.2,5.65,5.65,0,0,0,1.36.21C170.47,173.45,172.43,173.5,172.45,173.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,210.3a57.69,57.69,0,0,0,30.49-7.58s-7.93,15.87-30.58,13.36Z",
    style: {
      fill: "#8a4a43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,138.61c.37.83,3.45.21,7.15.4s6.72,1,7.15.19c.19-.38-.38-1.14-1.63-1.88a12.45,12.45,0,0,0-10.89-.45C184.47,137.5,183.84,138.21,184,138.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.13,140c.64.72,3.2,0,6.26,0s5.66.57,6.27-.16c.27-.36-.13-1.08-1.25-1.77a9.88,9.88,0,0,0-5.08-1.25,9.73,9.73,0,0,0-5,1.34C154.22,138.91,153.85,139.64,154.13,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,181a6.51,6.51,0,0,1,6.06-2.77h.22a3.26,3.26,0,0,1,2.4,5.47,5.75,5.75,0,0,1-3,1.83,5.44,5.44,0,0,1-4.45-.5A3.24,3.24,0,0,1,173.19,181Z",
    style: {
      fill: "#8a4a43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,176.29c-.15,0-.34.79-.92,2a9.68,9.68,0,0,1-7.86,5.46c-1.29.14-2.12,0-2.15.19s.77.48,2.18.53a8.79,8.79,0,0,0,8.49-5.91C182.13,177.19,182.06,176.3,181.94,176.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,165.71l-4.69-19c-4.22-5.82-.93-15.32,2.06-21.85s8.69-11.54,15-14.92,13.35-5.29,20.33-7a38.86,38.86,0,0,1-16.75,21.13S153.13,132,151,141.3C148.76,151.49,148.71,165.71,148.71,165.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.07,114.93l33.07,19.87a107.48,107.48,0,0,0,7.05,29.74c6.1-5.22,9.87,4.84,11.7-2.89.1-.41-1.68,16.21-8.07,16.73l-1,18.07,31.54-7.76s-1.7-21.9-7.08-35.19c-3.35-8.26-5.12-15.19-8.42-23.47-2.51-6.27-6.95-15.64-10.29-20.1-7.16-9.57-33.69-10-33.69-10-11.69,2.76-3.82,1.45-13.67,8.34l-3.36,9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.18,164.41c0-4.77,5.09-8.24,9.43-6.09,2.38,1.19,4.3,3.72,4.37,8.79.18,13.52-13.68,10.93-13.71,10.54S215.21,170,215.18,164.41Z",
    style: {
      fill: "#b56760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,172.47c.06,0,.25.16.65.34a2.49,2.49,0,0,0,1.8,0c1.45-.55,2.64-2.83,2.67-5.27a7.71,7.71,0,0,0-.71-3.36,2.78,2.78,0,0,0-1.83-1.78,1.23,1.23,0,0,0-1.41.67c-.18.38-.09.64-.16.67s-.3-.22-.2-.78a1.56,1.56,0,0,1,.53-.86,1.82,1.82,0,0,1,1.32-.36,3.35,3.35,0,0,1,2.54,2.06,7.87,7.87,0,0,1,.88,3.75c0,2.73-1.43,5.3-3.42,5.89a2.6,2.6,0,0,1-2.2-.33C219.43,172.8,219.36,172.5,219.4,172.47Z",
    style: {
      fill: "#8a4a43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,99.9a3.76,3.76,0,0,1-.57.81c-.41.49-1,1.17-1.84,2-1.6,1.61-3.91,3.74-6.47,6.07s-4.86,4.45-6.5,6a36.62,36.62,0,0,1-2.66,2.52,3.49,3.49,0,0,1,.59-.79c.41-.49,1-1.17,1.81-2,1.58-1.65,3.85-3.82,6.41-6.15l6.57-6C189.86,100.9,190.78,99.85,190.84,99.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,111.35a6.55,6.55,0,0,1,.88-1,26.13,26.13,0,0,1,2.75-2.51,30.33,30.33,0,0,1,10.93-5.5,12,12,0,0,1,6.77-.09,6.72,6.72,0,0,1,4.21,3.55,5.18,5.18,0,0,1,.19,3.72,3.51,3.51,0,0,1-.46.92q-.21.28-.24.27a11,11,0,0,0,.51-1.25,5.23,5.23,0,0,0-.34-3.51,6.37,6.37,0,0,0-4-3.24,11.82,11.82,0,0,0-6.5.13,32.12,32.12,0,0,0-10.83,5.29C155.42,110,154.12,111.42,154.05,111.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,125a5.52,5.52,0,0,1,.86-1c.58-.6,1.44-1.46,2.52-2.49a47.6,47.6,0,0,1,9.28-7.12,19.66,19.66,0,0,1,6-2.33,7.74,7.74,0,0,1,5.23.78,5.71,5.71,0,0,1,2.4,2.64,4.34,4.34,0,0,1,.25,1,1.28,1.28,0,0,1,0,.34c-.06,0-.1-.46-.45-1.21a5.76,5.76,0,0,0-2.39-2.4,7.5,7.5,0,0,0-5-.63,19.86,19.86,0,0,0-5.87,2.32,53.58,53.58,0,0,0-9.28,6.93l-2.63,2.36A6.88,6.88,0,0,1,146.49,125Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.65,179a4.72,4.72,0,1,1-4.88-4.56A4.72,4.72,0,0,1,225.65,179Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,314.05c-1.13.75-13.6,3.77-16.62,11.71s-19.06,24.06-7.45,39.8L139,352.21Z",
    style: {
      fill: "#303479"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.94,365.6v0a20.73,20.73,0,0,1-3.94-9.13,21.83,21.83,0,0,1,.52-8.84c1.43-5.71,4.68-11,7.29-15.32a46.53,46.53,0,0,0,3.58-6.54c2.47-6.49,11.25-9.7,15-11.07A12.58,12.58,0,0,0,139,314l0,0v38.22h0ZM139,314.09a15.22,15.22,0,0,1-1.6.64c-3.74,1.36-12.51,4.57-15,11a45.55,45.55,0,0,1-3.58,6.55c-2.61,4.28-5.86,9.6-7.28,15.31a21.68,21.68,0,0,0-.52,8.81,20.75,20.75,0,0,0,3.91,9.09l24-13.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.8 248.28 168.77 221.05 218.33 200.37 220.09 210.53 186.33 227.71 166.8 248.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.09,204.54s-30.36,12.28-43.83,24.28c-12.66,11.28-39,55.76-41.82,67.89s-2.27,45.68-2.27,45.68-.07,34.62-.07,35.47S110.39,434.55,114.33,465H238.16s3.67-42.88-4.79-59.52-8.75-13.26-8.75-13.26,5.08-5.64,4.52-10.72a22,22,0,0,0-3.67-9.3l21.72-67.7s2.25-34.13-3.67-57C238,226.12,235.9,227.33,229,220.48c-.15-.14.09.19,0,0l-6.31-5.17Z",
    style: {
      fill: "#303479"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,411.49c-.38-1.46,9.38-18.79,9.38-18.79l56,9.4,3.89,15.72Z",
    style: {
      fill: "#303479"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,411.49l.37,0,1,.07,4,.32L159,413.16l49.27,4.41-.28.31c-.94-3.81-1.93-7.81-2.94-11.87-.32-1.3-.64-2.6-1-3.85l.21.19-55.95-9.48.18-.09c-3.24,5.74-5.73,10.38-7.36,13.6-.82,1.61-1.41,2.88-1.77,3.75a7.28,7.28,0,0,0-.35,1c-.06.23,0,.34,0,.35a2.81,2.81,0,0,1,.31-1.4c.33-.89.9-2.16,1.69-3.79,1.58-3.26,4-7.92,7.23-13.69l.06-.1.12,0,56,9.31.17,0,0,.16.95,3.85c1,4.07,2,8.07,2.94,11.88l.09.35-.36,0-49.4-4.62-14.57-1.41-3.91-.4-1-.11A1.26,1.26,0,0,1,139,411.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127,384.6l1.25,10.14c8.92,6.32,21.54,5.12,31.09-.22s16.63-14.11,23.17-22.87c19.85-26.55,37.14-55.22,48.93-86.2C200.69,322.38,158.07,347.92,127,384.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M227,233.19c10.39,8.27,19.45,34.15,3.36,56.52,0,0-70.3,95.38-81.94,103s-27.31,3.13-31.79-8.06-2.69-21.94,3.58-29.55,47.47-80.16,47.47-80.16,9.39-33.62,25.4-43.38",
    style: {
      fill: "#303479"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.06,231.55l-.72.51a24.94,24.94,0,0,0-2.08,1.55,41.83,41.83,0,0,0-6.78,7.4c-5.18,7.06-11,18.62-15.66,34v0c-9,15.91-20.32,35.72-33.46,58-3.31,5.54-6.7,11.26-10.36,17-1,1.42-1.82,2.89-2.88,4.28-.51.71-1,1.4-1.55,2.07a24.3,24.3,0,0,0-1.43,2.15,27.27,27.27,0,0,0-2.21,4.7,27.61,27.61,0,0,0-1.24,5.11,29.94,29.94,0,0,0,.45,10.62c.2.88.41,1.76.69,2.62s.57,1.72.88,2.57.75,1.64,1.13,2.46l.74,1.14a7.71,7.71,0,0,0,.8,1.1,19.54,19.54,0,0,0,9,6.17,23.06,23.06,0,0,0,11,.95,22.7,22.7,0,0,0,9.47-3.87,66.17,66.17,0,0,0,7.25-7.25c4.54-5.1,8.83-10.29,13-15.42,8.32-10.28,16.15-20.35,23.57-30s14.39-18.84,20.89-27.47l9.38-12.52,4.4-5.91c1.42-1.94,2.9-3.78,4.08-5.74A45,45,0,0,0,237,276c.27-1,.54-2,.8-2.94s.37-1.95.55-2.91a44.14,44.14,0,0,0-2.52-23.89,35.33,35.33,0,0,0-5.93-10.14c-.45-.51-.81-1-1.18-1.33l-.95-.88c-.51-.47-.76-.73-.76-.73s.28.23.8.69l1,.86c.39.34.75.82,1.21,1.32a34.82,34.82,0,0,1,6,10.14,46.26,46.26,0,0,1,3.22,18.36,46.88,46.88,0,0,1-.58,5.65c-.18,1-.28,2-.54,2.93s-.53,2-.81,3A45,45,0,0,1,231.69,288c-1.19,2-2.67,3.82-4.08,5.77l-4.39,5.92q-4.5,6-9.36,12.54c-6.48,8.64-13.45,17.86-20.85,27.5s-15.23,19.72-23.55,30c-4.17,5.14-8.45,10.34-13,15.44-1.13,1.28-2.31,2.54-3.5,3.78a36.92,36.92,0,0,1-3.83,3.55,23.13,23.13,0,0,1-9.7,4,23.46,23.46,0,0,1-11.29-1,20,20,0,0,1-9.18-6.34,7.14,7.14,0,0,1-.83-1.13l-.76-1.17c-.39-.85-.85-1.67-1.17-2.54s-.65-1.72-.89-2.6-.49-1.77-.69-2.66a28.8,28.8,0,0,1,.81-16,28.72,28.72,0,0,1,2.26-4.79c.46-.75.93-1.49,1.46-2.19s1.06-1.38,1.55-2.07c1-1.36,1.92-2.84,2.87-4.25,3.65-5.73,7.05-11.44,10.37-17,13.15-22.21,24.48-42,33.57-57.88l0,0c4.66-15.39,10.6-26.93,15.84-34a40.07,40.07,0,0,1,6.87-7.36,23.59,23.59,0,0,1,2.11-1.52C192.8,231.7,193.06,231.55,193.06,231.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,305.38s-1.81-4.73-5.43-5.36-10.61,0-10.61,0-3.08,2.32-3.05,5.5a22.9,22.9,0,0,0,.65,5.4s-2.53-3.41-5.86-.18-6.25,9.78-6.25,9.78-4.43,1.42-6.12,3.57a19.61,19.61,0,0,0-2.69,5.63,7.22,7.22,0,0,0-3.06,6.92,9,9,0,0,0,4.7,6.69s13.21,9.73,14.82,8.47,4.92-3.24.17-7.45l-7.73-6.85,2.24-3.46s12.93,8.89,15,8.46,5.6-.5,4.15-3.69-13.53-12.49-13.53-12.49l1.43-5s14,9.46,16.27,7.95,4.33-2.22,2-5.34-12.42-10.57-12.42-10.57l4.13-3.86S160.64,311.21,162.06,305.38Z",
    style: {
      fill: "#b56760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,215.31l-.35.1-1,.28c-.9.23-2.23.58-3.94,1.07a141,141,0,0,0-14.21,4.76c-1.47.59-3,1.24-4.55,2-.78.37-1.57.75-2.36,1.18-.39.22-.8.42-1.19.65s-.77.47-1.13.75a62.93,62.93,0,0,0-8.38,8.36c-5.48,6.33-11.07,13.67-16.79,21.45s-11,15.36-15.75,22.27c-2.37,3.46-4.59,6.76-6.65,9.87a81.61,81.61,0,0,0-5.31,8.87,100.56,100.56,0,0,0-5.56,13.91c-.55,1.69-.94,3-1.2,3.9l-.29,1a2,2,0,0,1-.12.35s0-.13.07-.36l.24-1c.23-.9.59-2.23,1.1-3.93a95.85,95.85,0,0,1,5.43-14,80.49,80.49,0,0,1,5.28-8.94c2-3.13,4.26-6.44,6.61-9.91,4.72-6.93,10-14.49,15.73-22.3s11.33-15.13,16.85-21.47a61.41,61.41,0,0,1,8.49-8.38c.37-.29.78-.52,1.17-.78s.81-.43,1.21-.65c.79-.43,1.59-.81,2.38-1.17,1.57-.74,3.1-1.39,4.58-2a130.35,130.35,0,0,1,14.3-4.62c1.72-.46,3.06-.77,4-1l1-.22A1.8,1.8,0,0,1,222.65,215.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.79,386.24a11,11,0,0,1-1.55-.88c-1-.58-2.37-1.49-4.05-2.66a94.47,94.47,0,0,1-22.57-22.45c-1.18-1.67-2.1-3.05-2.69-4a12.52,12.52,0,0,1-.88-1.55,10.58,10.58,0,0,1,1,1.43c.64.95,1.6,2.29,2.82,3.93a105.85,105.85,0,0,0,22.49,22.37c1.64,1.21,3,2.16,3.94,2.79A12.62,12.62,0,0,1,214.79,386.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.82 411.66 142.51 417.82 205.89 417.61 140.82 411.66"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurTeam);
export default __webpack_public_path__ + "static/media/our_team.45ea832c37d62268b9fa10071cb8c458.svg";
export { ForwardRef as ReactComponent };